/** @jsx jsx */
import { jsx } from '@emotion/core'
import _ from 'lodash'
import { authStore, chattingStore, componentStore, globalStore, reportStore, userStore } from '@store/index'
import { UploadImgStyle } from '@views/Popup/Chat/index.style'
import { UserPickNullOngoingBetInfo } from '@views/Home/UserPick/Components/UserPickNullOngoingBetInfo'
import { UserPickIsOngoingBetInfo } from '@views/Home/UserPick/Components/UserPickIsOngoingBetInfo'
import { EtcMarketFilterList } from '@views/Home/UserPick/UserPickContents/EtcMarketFilterList'
import { Schema$UserPickMarket } from '@interface/user-pick'
import { RatingInfo } from '@views/MyPage/UserActivity/RatingInfo'
import { Schema$UserActivitySummary } from '@interface/user-activity'
import { MatchRecord, MatchRecordSimpleMatchInfo } from '@views/MatchRecord'
import * as Utils from '@utils/utils'
import { showToast, TOAST_TYPE } from '@utils/utils'
import { AdvReportList } from '@components/AdvReport'
import { COMMUNICATION_BLOCK_TYPE, GlobalStoreKey, USER_REPORT_TYPE } from '@v2/constants/common'
import { AdvBlockList } from '@components/AdvBlock'
import { ERR } from 'adv-protocol/src/ErrorCodes'
import { UserPenaltyInfo } from '@components/AdvPenalty/UserPenaltyInfo'
import { UserTitleSetting } from '@components/UserTitle/userTitleSetting'
import { UnableToJoinInfo } from '@views/Login/KakaoLogin/UnableToJoinInfo'
import { TransferApplicationCompletedInfo } from '@views/Login/KakaoLogin/TransferApplicationCompletedInfo'
import { ApplyForAccountTransferInfo } from '@views/Login/KakaoLogin/ApplyForAccountTransferInfo'
import { KakaoServiceTerminationInfo } from '@views/Login/KakaoLogin/KakaoServiceTerminationInfo'
import { ApplyForNewAccount } from '@views/Login/KakaoLogin/ApplyForNewAccount'
import { TransferableAccount } from '@store/userStore'
import { ACCOUNT_TYPE, LogoutType } from '@interface/common'
import StorageUtils from '@utils/storage-utils'
import { SoccerCardCountGuide } from '@views/Home/UserPick/Components/SoccerCardCountGuide'

export default class DialogUtils {

  static showUserPickNullOngoingBetInfo(): void {
    globalStore.pushDialogOk({
      custom: <UserPickNullOngoingBetInfo/>,
      className: 'box-type big-size character-popup',
      singlePress: '닫기',
    })
  }

  static showUserPickIsOngoingBetInfo(props: { closeCallback: () => void }): void {
    globalStore.pushDialogOk({
      custom: <UserPickIsOngoingBetInfo/>,
      className: 'box-type big-size character-popup',
      singlePress: '닫기',
      callbackCloseDialog: props.closeCallback,
    })
  }


  static showImagePreview(props: { imageSrc: string }): void {
    const { imageSrc } = props
    globalStore.pushDialogOk({
      custom: (
        <div css={UploadImgStyle}>
          <img src={imageSrc} alt="업로드 이미지"/>
        </div>
      ),
      className: 'image-full-popup',
      singlePress: '닫기',
      // 뒷배경 클릭 시 닫히도록
      callbackCloseDialogBg: () => {
        globalStore.closeDialog()
      },
    })
  }

  static showPenaltyInfo(penaltyMessage: string): void {
    globalStore.pushDialogOk({
      custom: (
        <UserPenaltyInfo penaltyMessage={penaltyMessage}/>
      ),
      className: 'box-type big-size character-popup',
      singlePress: '닫기',
      callbackCloseDialogBg: () => {
        globalStore.closeDialog()
      },
    })
  }

  static showUserPickEtcMarketFilterList(userPickEtcMarkets: Schema$UserPickMarket[], matchId: number): void {
    globalStore.pushDialogOk({
      title: '베팅타입 선택',
      custom: <EtcMarketFilterList markets={userPickEtcMarkets} matchId={matchId}/>,
      className: 'middle-size box-type',
      singlePress: '닫기',
      callbackCloseDialog: () => {
        globalStore.closeDialog()
      },
      // 뒷배경 클릭 시 닫히도록
      callbackCloseDialogBg: () => {
        globalStore.closeDialog()
      },
    })
  }

  static showUserActivityRatingInfo(userActivity: Schema$UserActivitySummary): void {
    globalStore.pushDialogOk({
      title: '활동등급',
      custom: <RatingInfo userActivity={userActivity}/>,
      className: 'box-type big-size',
      callbackCloseDialog: () => {
        globalStore.closeDialog()
      },
      // 뒷배경 클릭 시 닫히도록
      callbackCloseDialogBg: () => {
        globalStore.closeDialog()
      },
    })
  }

  static showMatchRecord(
    matchRecordSimpleMatchInfo: MatchRecordSimpleMatchInfo,
  ): void {
    globalStore.pushDialogOk({
      title: '',
      custom: (
        <MatchRecord
          matchRecordSimpleMatchInfo={matchRecordSimpleMatchInfo}
        />
      ),
      className: 'box-type big-size',
      // 뒷배경 클릭 시 닫히도록
      callbackCloseDialogBg: () => {
        globalStore.closeDialog()
      },
    })
  }

  // static showUserDetailInfo(userPromiseId: string): void {
  //   globalStore.pushDialogOk({
  //     custom: <UserPickUserInfo userPromiseId={userPromiseId}/>,
  //     className: 'big-size box-type',
  //     singlePress: '닫기',
  //     callbackCloseDialog: () => {
  //       globalStore.closeDialog()
  //     },
  //     // 뒷배경 클릭 시 닫히도록
  //     callbackCloseDialogBg: () => {
  //       globalStore.closeDialog()
  //     },
  //   })
  // }

  static userPickCommentDelete(): void {
    globalStore.pushDialogYesNo({
      title: '답글 삭제',
      text: ['정말 삭제하시겠습니까?'],
      wrapClassName: 'box-type small-size',
      negativePress: '취소',
      positivePress: '삭제',
      callbackPositive: () => {
        showToast(TOAST_TYPE.INFO, '삭제되었습니다.')
      },
      callbackCloseDialog: () => {
        globalStore.closeDialog()
      },
      // 뒷배경 클릭 시 닫히도록
      callbackCloseDialogBg: () => {
        globalStore.closeDialog()
      },
    })
  }

  static showUserReport(params: {
    reportType: USER_REPORT_TYPE
    targetId: string
    targetUserPromiseId: string
    callbackReport?: (result) => void
  }): void {
    globalStore.pushDialogYesNo({
      title: '신고사유',
      custom: <AdvReportList/>,
      className: 'new-big-size checkbox',
      negativePress: '취소',
      positivePress: '신고',
      callbackPositiveFreeze: async () => {
        let result = false
        if (_.isEmpty(reportStore.selectedReportTextList)) {
          showToast(TOAST_TYPE.WARN, '신고사유를 선택해주세요.')
        } else {
          const reportResult = await reportStore.createReport(params)
          if (reportResult) {
            if (reportResult.alreadyExists) {
              showToast(TOAST_TYPE.INFO, '이미 신고한 글입니다.')
            } else {
              showToast(TOAST_TYPE.INFO, '신고되었습니다.')
            }
            result = true
          } else {
            showToast(TOAST_TYPE.ERROR, '신고에 실패 하였습니다.')
          }

          if (params.callbackReport) {
            params.callbackReport(result)
          }
          return result
        }
      },
      callbackCloseDialogBg: () => {
        globalStore.closeDialog()
      },
    })
  }
  static showUserBlock(
      userPromiseId: string,
      userNick: string,
      userProfileImg: string,
      successCallback?: (userPromiseId: string, blockTypes: COMMUNICATION_BLOCK_TYPE[]) => void
  ): void {
    globalStore.pushDialogYesNo({
      custom: (
        <AdvBlockList
          userPromiseId={userPromiseId}
          userNick={userNick}
          userProfileImg={userProfileImg}
        />
      ),
      // TODO 체크박스 전체 해제상태시 disabled 클래스 추가해주시면 됩니다.
      className: 'new-slide-type',
      negativePress: '취소',
      positivePress: '확인',
      callbackPositiveFreeze: async () => {
        if (_.isEmpty(componentStore.selectedUserCommunicationBlocks)) {
          showToast(TOAST_TYPE.INFO, '선택된 차단 목록이 없습니다.')
          return false
        }

        const result = await componentStore.setRegistrationCommunicationBlock(userPromiseId)

        if (!result) {
          showToast(TOAST_TYPE.INFO, '차단에 실패했습니다.')
          return false
        }

        if (!_.isNil(result.errcode)) {
          if (result.errcode === ERR.COMMUNICATION_BLOCK_FAIL_BLOCK_USER_LIMIT_EXCEED) {
            const blockLimitCount = globalStore.findGlobalSetting(
              GlobalStoreKey.COMMUNICATION_BLOCK_USER_LIMIT_COUNT,
            )?.value || 20

            showToast(TOAST_TYPE.ERROR, `${blockLimitCount} 명까지 차단할 수 있습니다.`)
          } else if (result.errcode === ERR.COMMUNICATION_BLOCK_FAIL_CI_VALUE_IS_MINE) {
            showToast(TOAST_TYPE.INFO, '동일명의 계정은 차단할수 없습니다.')
          } else {
            showToast(TOAST_TYPE.INFO, '차단에 실패했습니다.')
          }
          return false
        }

        const isChatBlock = _.includes(componentStore.selectedUserCommunicationBlocks,
          COMMUNICATION_BLOCK_TYPE.CHAT_AND_SPORT_TALK)
        if (isChatBlock) {
          chattingStore.addChatBlockUserId(userPromiseId)
        } else {
          chattingStore.removeChatBlockUserId(userPromiseId)
        }

        showToast(TOAST_TYPE.INFO, '차단되었습니다.')
        if (successCallback) {
          successCallback(userPromiseId, componentStore.selectedUserCommunicationBlocks)
        }
        return true
      },
      callbackCloseDialog: () => {
        componentStore.resetSelectedUserCommunicationBlocks()
        globalStore.closeDialog()
      },
      // 뒷배경 클릭 시 닫히도록
      callbackCloseDialogBg: () => {
        componentStore.resetSelectedUserCommunicationBlocks()
        globalStore.closeDialog()
      },
    })
  }
  static showUserUnBlock(
    userPromiseId: string,
    successCallback?: (userPromiseId: string, blockTypes: COMMUNICATION_BLOCK_TYPE[]) => void
  ): void {
    globalStore.pushDialogYesNo({
      title: '차단해제',
      text: ['모든 차단을 해제하시겠습니까?'],
      className: 'new-middle-size',
      negativePress: '취소',
      positivePress: '해제',
      callbackPositiveFreeze: async () => {
        const result = await componentStore.unblockCommunicationBlockUser(userPromiseId)
        if (!result) {
          showToast(TOAST_TYPE.INFO, '차단 해제에 실패했습니다.')
          return false
        }

        componentStore.removeCommunicationBlockUserInfo(userPromiseId)
        chattingStore.removeChatBlockUserId(userPromiseId)
        showToast(TOAST_TYPE.INFO, '차단 해제되었습니다.')

        if (successCallback) {
          successCallback(userPromiseId, componentStore.selectedUserCommunicationBlocks)
        }
        return true
      },
      callbackCloseDialog: () => {
        componentStore.resetSelectedUserCommunicationBlocks()
        globalStore.closeDialog()
      },
      // 뒷배경 클릭 시 닫히도록
      callbackCloseDialogBg: () => {
        componentStore.resetSelectedUserCommunicationBlocks()
        globalStore.closeDialog()
      },
    })
  }

  static userTitleSetting(): void {
    globalStore.pushDialogOk({
      title: '칭호설정',
      custom: <UserTitleSetting/>,
      className: 'box-type big-size',
      singlePress: '닫기',
      callbackCloseDialog: () => {
        globalStore.closeDialog()
      },
      // 뒷배경 클릭 시 닫히도록
      callbackCloseDialogBg: () => {
        globalStore.closeDialog()
      },
    })
  }

  static showKakaoNewUserInfo(): void {

    globalStore.pushDialogOk({
      custom: <UnableToJoinInfo/>,
      wrapClassName: 'ant-popover kakao-login',
      className: 'box-type big-size character-popup',
      singlePress: '닫기',
      callbackCloseDialogBg: () => {
        globalStore.closeDialog()
      },
    })
  }

  static showTransferApplicationCompletedInfo(
    confirmCallback: () => void
  ): void {
    globalStore.pushDialogOk({
      custom: <TransferApplicationCompletedInfo/>,
      wrapClassName: 'ant-popover kakao-login',
      className: 'box-type big-size character-popup',
      singlePress: '닫기',
      callbackCloseDialog: () => {
        globalStore.closeDialog()
        if (confirmCallback) {
          confirmCallback()
        }
      },
      // 뒷배경 클릭 시 닫히도록
      callbackCloseDialogBg: () => {
        globalStore.closeDialog()
      },
    })
  }

  static showApplyForAccountTransferInfo(
    accountInfo: TransferableAccount,
    successCallback: () => void,
    processCompleteCallback: () => void,
  ): void {
    const targetUserPromiseId = accountInfo?.userPromiseId
    globalStore.pushDialogYesNo({
      title: '계정 이관 신청을 하시겠습니까?',
      custom: <ApplyForAccountTransferInfo
        accountInfo={accountInfo}
      />,
      wrapClassName: 'ant-popover kakao-login',
      className: 'new-big-size',
      negativePress: '취소',
      positivePress: '확인',
      callbackPositiveFreeze: async (): Promise<boolean> => {
        const { isComplete, errcode } = await userStore.registerAccountTransfer(targetUserPromiseId)

        if (_.isNil(errcode) && isComplete) {
          if (processCompleteCallback) {
            processCompleteCallback()
          }

          setTimeout(() => {
            this.showTransferApplicationCompletedInfo(successCallback)
          })
          return true
        }

        Utils.showToast(TOAST_TYPE.ERROR, '다시 진행해주시기 바랍니다.')
        return false
      },
      callbackCloseDialog: () => {
        if (processCompleteCallback) {
          processCompleteCallback()
        }
      },
      // 뒷배경 클릭 시 닫히도록
      callbackCloseDialogBg: () => {
        if (processCompleteCallback) {
          processCompleteCallback()
        }
        globalStore.closeDialog()
      },
    })
  }

  static showKakaoServiceTerminationInfo(): void {
    globalStore.pushDialogOk({
      custom: <KakaoServiceTerminationInfo/>,
      wrapClassName: 'ant-popover kakao-login',
      className: 'box-type big-size character-popup',
      singlePress: '닫기',
      callbackCloseDialog: () => {
        globalStore.closeDialog()
      },
      // 뒷배경 클릭 시 닫히도록
      callbackCloseDialogBg: () => {
        globalStore.closeDialog()
      },
    })
  }

  static showNewAccountApplicationCompleteKakao(callbackClose: () => void): void {
    globalStore.pushDialogOk({
      custom: <ApplyForNewAccount/>,
      wrapClassName: 'ant-popover kakao-login',
      className: 'box-type big-size character-popup',
      singlePress: '카카오 로그인하기',
      callbackCloseDialog: () => {
        authStore.logout(LogoutType.USER, false).catch(console.error)
        window.Kakao.Auth.login({
          success(result) {
            window.Kakao.Auth.setAccessToken(result.access_token)
            window.Kakao.API.request({
              url: '/v2/user/me',
              success(user) {
                const params = {
                  username: user.id,
                  password: 'null',
                  email: user.kakao_account.email,
                }
                StorageUtils.saveSignType(ACCOUNT_TYPE.KAKAO)
                StorageUtils.removeUserId()
                authStore.loginByKakao(params).catch(console.error)

                if (callbackClose) {
                  callbackClose()
                }
              },
              fail(err) {
                console.log('kakao user info fail', err)
                if (callbackClose) {
                  callbackClose()
                }
              },
            })
          },
          fail(err) {
            console.log('kakao auth fail.')
            if (callbackClose) {
              callbackClose()
            }
          },
        })


      },
      // 뒷배경 클릭 시 닫히도록
      callbackCloseDialogBg: () => {
        globalStore.closeDialog()
        if (callbackClose) {
          callbackClose()
        }
      },
    })
  }

  static showDeleteSportTalk(callbackPositive: () => void): void {
    globalStore.pushDialogYesNo({
      title: '스포츠톡 삭제',
      text: ['삭제 후 복원이 불가능합니다.', '삭제하시겠습니까?'],
      className: 'new-middle-size',
      negativePress: '취소',
      positivePress: '삭제',
      callbackPositive,
      callbackCloseDialog: () => {
        globalStore.closeDialog()
      },
      // 뒷배경 클릭 시 닫히도록
      callbackCloseDialogBg: () => {
        globalStore.closeDialog()
      },
    })
  }

  static showCardCountGuide(): void {
    globalStore.pushDialogOk({
      custom: <SoccerCardCountGuide/>,
      className: 'box-type big-size character-popup',
      singlePress: '닫기',
      // 뒷배경 클릭 시 닫히도록
      callbackCloseDialogBg: () => {
        globalStore.closeDialog()
      },
    })
  }

  static showRegisterAllFavorites(callbackPositive: () => void): void {
    globalStore.pushDialogYesNo({
      title: '전체 관심등록',
      text: ['모든 유저를 관심 등록하시겠습니까?'],
      className: 'new-middle-size',
      negativePress: '취소',
      positivePress: '등록',
      callbackPositive,
      callbackCloseDialog: () => {
        globalStore.closeDialog()
      },
      // 뒷배경 클릭 시 닫히도록
      callbackCloseDialogBg: () => {
        globalStore.closeDialog()
      },
    })
  }
  static showUnregisterAllFavorites(callbackPositive: () => void): void {
    globalStore.pushDialogYesNo({
      title: '전체 관심해제',
      text: ['모든 유저를 관심 해제하시겠습니까?'],
      className: 'new-middle-size',
      negativePress: '취소',
      positivePress: '해제',
      callbackPositive,
      callbackCloseDialog: () => {
        globalStore.closeDialog()
      },
      // 뒷배경 클릭 시 닫히도록
      callbackCloseDialogBg: () => {
        globalStore.closeDialog()
      },
    })
  }
}
